module.exports = "https://www.gc-pro.gnp.com.mx/f4b87e74c3e2e4ae1c33868a4d5b4989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/40.svg
// module id = 8043
// module chunks = 0